import { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import { ReactComponent as IconBack } from "assets/images/icons/project-icons/arrow_back.svg"
import Table from "components/__new/common/Table";
import ContentLoading from "components/__new/common/ContentLoading";
import CurrencyFormat from "utils/currencyFormat";
import { renderStatusColor } from "utils/statusColor";
import { useHistory } from "react-router-dom";
import TransactionDetailsWrapper from "components/__new/common/TransactionDetailsWrapper";
import DateFormat, { TimeFormat } from "utils/dateFormat"


export const RecurringTransferHistory = () => {
    // const dispatch = useDispatch();
    const [detailsOpen, setDetailsOpen] = useState(false);
    // const [selected, setSelected] = useState(null);
    const history = useHistory();
    
    const transaction = {
                "_id": "662a4443ee9f31ab62f7578d",
                "walletId": 903698243,
                "reference": "POR|65EF019|1714046018782",
                "transactionRef": "PORT-FE19CCA663A2448",
                "product": "general",
                "type": "debit",
                "status": "successful",
                "target": "balance",
                "description": "Debit for N850 portharcourt_electric with Ref. POR|65EF019|1714046018782",
                "amount": 85000,
                "charge": 0,
                "revenue": 1200,
                "sourceType": "bill-payment",
                "previousBalance": 460854263,
                "newBalance": 460769263,
                "createdAt": "2024-04-25T11:53:39.232Z",
                "updatedAt": "2024-04-25T11:53:39.232Z",
                "__v": 0
            }
    

    return (
        <div>

            <DynamicHeadTag
                headerText="Recurring Transfer History"
            />
            
            <TransferDetailsModal
                isOpen={detailsOpen}
                setIsOpen={setDetailsOpen}
                transaction={transaction}
            />
            
            <div className="w-full lg:w-1/2 mb-5 flex items-center">
                <div className="w-10 h-10 flex items-center justify-center mr-3 bg-[#ececec] rounded-md">
                    <IconBack
                        className='cursor-pointer'
                        onClick={() => history.goBack()}
                    />
                </div>
                
                <div className="page-title flex">
                    View History
                </div>
            </div>
            
            <div className="mt-6 box">
                
                <div className="flex items-center justify-start w-max">
                    <div className="font-medium">Recurring Transfers&nbsp;</div>
                    
                    <div className="label h-6 text-sm font-normal text-ep-primary-600 bg-[#ecf2f2]">
                        <ContentLoading
                            loading={false}
                            data={"400 transfers"}
                            // data={<>{transactions?.data?.totalDocs ?? "-"} {pluralize(transactions?.data?.totalDocs, "transfer", "transfers")}</>}
                        />
                    </div>
                </div>
            </div>

            <div className="bg-white">

                <Table classTable="table-hover">
                    <Table.Head>
                        <th>Date</th>
                        <th>Recipient</th>
                        <th>Narration</th>
                        <th>Status</th>
                        <th>Amount</th>
                        <th>Balance</th>
                    </Table.Head>
                    <Table.Body>

                        {/* <TableContent
                            loading={transactionsLoading}
                            loadingText="Fetching Transfers"
                            data={[]}
                            colspan={6}
                            emptyUI={
                                <TableEmptyData
                                    useSubtitle
                                />
                            }
                        /> */}
                        
                        <tr onClick={() => { setDetailsOpen(true) }}>
                            <td>
                                <div className="py-3">
                                    Jan 18, 2024 at 10:08 AM
                                </div>
                            </td>
                            
                            <td className="capitalize">
                                Roy Unachukwu
                            </td>
                                {/* {CurrencyFormat(400000)} */}
                            
                            <td className="capitalize">
                                Transport
                            </td>
                            
                            <td>
                                <div className={"text-xs capitalize label " + renderStatusColor("success")}>
                                    Successful
                                </div>
                            </td>
                            
                            <td>
                                {CurrencyFormat("99999")}
                            </td>
                            
                            <td>
                                {CurrencyFormat("99999")}
                            </td>
                        </tr>

                        {/* {transactionsLoading === false && transactions?.data?.docs?.map((transaction) => {
                            
                            return (
                                <tr key={transaction._id} onClick={() => openTransactionDetails(transaction)}>
                                    <td>
                                        <div className="py-2">{DateFormat(transaction.createdAt)} at {TimeFormat(transaction.createdAt)}</div>
                                    </td>
                                    <td className="capitalize">
                                        {transaction?.recipient?.accountName?.toLowerCase() || "N/A"}
                                    </td>
                                    <td className="capitalize">
                                        {transaction?.narration || "N/A"}
                                    </td>
                                    <td>
                                        <div className={"text-xs capitalize label " + renderStatusColor(transaction.status)}>
                                            {transaction.status}
                                        </div>
                                    </td>
                                    <td>
                                        {CurrencyFormat(transaction.amount / 100)}
                                    </td>
                                    <td>
                                        {CurrencyFormat(transaction.newBalance / 100)}
                                    </td>
                                </tr>
                            )}
                        )} */}
                    </Table.Body>
                </Table>
            </div>
        </div>
    )
}



const TransferDetailsModal = ({transaction, setIsOpen, isOpen}) => {
    const transactionAmount = `-${CurrencyFormat(transaction?.amount / 100)}`
    
    return (
        <TransactionDetailsWrapper
            title="Debit"
            subtitle="Transfer"
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            amount={transactionAmount}
            status={transaction?.status}
            documentTitle={`Recurring Transfer History - ${DateFormat(transaction?.createdAt)}`}>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Transaction Number</div>
                    <div className="text-ep-gray-700">
                        {transaction?.reference}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Time Stamp</div>
                    <div className="text-ep-gray-700">
                        {DateFormat(transaction?.createdAt)} at {TimeFormat(transaction?.createdAt)}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Recipient Name</div>
                    <div className="text-ep-gray-700 capitalize">
                        {transaction?.recipient?.accountName?.toLowerCase() ?? "N/A"}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Bank Name</div>
                    <div className="text-ep-gray-700 capitalize">
                        {transaction?.recipient?.bankName?.toLowerCase() ?? "N/A"}
                    </div>
                </div>
                
                <div className="w-full flex items-center justify-between text-sm mt-7">
                    <div className="text-ep-gray-500">Account Number</div>
                    <div className="text-ep-gray-700 capitalize">
                        {transaction?.recipient?.accountNumber?.toLowerCase() ?? "N/A"}
                    </div>
                </div>
        </TransactionDetailsWrapper>
    )
}


export default RecurringTransferHistory;